import styled from '@emotion/styled';
import { COLORS, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { css } from '@emotion/react';

const chipBorderColor = '#C0C0C0';

const activeStyle = css`
  content: '';
  display: block;
  border: 1px solid ${COLORS.BLACK};
  border-radius: 50%;
  position: absolute;
  top: -3px;
  left: -3px;
  height: 26px;
  width: 26px;
  top: -3px;
  left: -3px;
`;

export const SwatchContainer = styled.div<{ active?: boolean }>`
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 4px 10px 0 0;
  cursor: pointer;
  ${MEDIA_QUERY.MOBILE} {
    margin: 0 6px 0 0;
  }

  &:after {
    ${({ active }) => {
      return active ? activeStyle : null;
    }}
  }
`;

export const SwatchRow = styled.div<{ mobileVisibility?: boolean }>`
  ${({ mobileVisibility }) => {
    if (!mobileVisibility) {
      return css`
        ${MEDIA_QUERY.MOBILE} {
          display: none;
        }
      `;
    }

    return null;
  }}
`;

export const SwatchHalf = styled.div<{ color: string }>`
  width: 100%;
  height: 10px;
  background-color: ${(prop) => prop.color};
`;

export const SwatchInnerContainer = styled.div<{ color: string }>`
  transform: rotate(-45deg);
  border-radius: 50%;
  display: inline-block;
  border: 1px solid ${chipBorderColor};
  overflow: hidden;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  background-color: ${(prop) => prop.color};
`;

export const MobileSwatch = styled.div`
  position: relative;
  bottom: 5px;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: none;
  }
`;
